'use strict';

var d3 = require('d3');
var RomSummaryLineGraphPinLine = function RomSummaryLineGraphPinLine() {
  return function () {
    var chartData;
    var scales;
    var chartParams;
    var chartRange;

    /**
     * Pinned line SVG element
     */
    var pin;
    function appendPin(container) {
      container.selectAll('g.pin').remove();
      pin = container.append('g').attr('class', 'pin').style('display', 'none');

      // vertical line
      pin.append('line').attr('class', 'pin-line').attr('y1', 0).attr('y2', 1);
    }
    var pinLine = function pinLine(container) {
      appendPin(container);
    };
    pinLine.hide = function () {
      pin.style('display', 'none');
    };
    pinLine.show = function (mouseCoordinateX) {
      pin.select('.pin-line').attr('transform', 'translate(' + (scales.xScale.range()[d3.bisect(scales.xScale.range(), mouseCoordinateX) - 1] + scales.xScale.rangeBand() / 2) + ', 0)').attr('y1', scales.yScale.range()[0]).attr('y2', scales.yScale.range()[1]);
      pin.style('display', null);
    };
    pinLine.chartData = function (value) {
      if (!arguments.length) {
        return chartData;
      }
      chartData = value;
      return pinLine;
    };
    pinLine.scales = function (value) {
      if (!arguments.length) {
        return scales;
      }
      scales = value;
      return pinLine;
    };
    pinLine.chartParams = function (value) {
      if (!arguments.length) {
        return chartParams;
      }
      chartParams = value;
      return pinLine;
    };
    pinLine.chartRange = function (value) {
      if (!arguments.length) {
        return chartRange;
      }
      chartRange = value;
      return pinLine;
    };
    return pinLine;
  };
};
module.exports = RomSummaryLineGraphPinLine;